var map = {
	"./arrow-left-button.svg": "a788",
	"./arrow-right-button.svg": "b13c",
	"./bag.svg": "47fd",
	"./cart.svg": "daca",
	"./chat.svg": "9b69",
	"./close-white.svg": "72e4",
	"./close.svg": "8b1b",
	"./compare.svg": "c49d",
	"./delete.svg": "0d45",
	"./delivery.svg": "4a78",
	"./filters.svg": "1d60",
	"./heart-fill.svg": "587a",
	"./heart.svg": "7d16",
	"./menu-button.svg": "9ee6",
	"./more.svg": "0f4c",
	"./nav.svg": "2f12",
	"./notify.svg": "c760",
	"./out.svg": "495d",
	"./phone.svg": "c3bb",
	"./search.svg": "d103",
	"./self.svg": "2040",
	"./star.svg": "cc90",
	"./user.svg": "6aed",
	"./webcam.svg": "14f0",
	"./zoom.svg": "6705"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";